import type { OverridableComponent } from "@mui/material/OverridableComponent";
import type { SvgIconTypeMap } from "@mui/material/SvgIcon";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import TelemedicineOutlined from "../../assets/TelemedicineOutlined";
import type { Cliente } from "../../types/cliente";

export type MenuItem = {
  label: string;
  to: string;
  Icon: OverridableComponent<SvgIconTypeMap>;
  hidden?: boolean;
};

const menuItems: (cliente?: Cliente) => MenuItem[] = (
  cliente?: Cliente | null
) => [
  {
    label: "Assine já",
    to: "/app/assinar",
    Icon: ShoppingCartIcon,
    hidden: cliente?.planoId !== 1 || cliente?.tipoConta !== "C",
  },
  {
    label: "Telemedicina",
    to: "/app/telemedicina",
    Icon: TelemedicineOutlined,
  },
  {
    label: "Minha conta",
    to: "/app/minha-conta",
    Icon: AccountCircleOutlinedIcon,
  },
];

export default menuItems;
